// extracted by mini-css-extract-plugin
export default {"root":"NFh5vf","blackAndWhite":"oTREuH","theme":"J7zFtU"};